import React from 'react';

import { Link } from 'react-router-dom';

export const Page404 = () => (
  <div className="m-auto mt-14 flex h-[432px] w-[521px] flex-col items-center justify-center gap-2.5 rounded-modal bg-white shadow-md">
    <div className="flex h-[244px] w-[331px] flex-col items-center justify-center gap-y-8">
      <div className="flex w-full flex-col items-center gap-y-4">
        <div className="flex w-full flex-col items-center gap-y-4">
          <img src="/images/optimized/checkmate_logo.webp" alt="checkmate logo" className="h-9 object-cover" />

          <div className="flex w-full flex-col items-center gap-y-1.5">
            <h1 className="text-h3">Access Error</h1>
          </div>
        </div>
        <p className="text-center text-c2 text-gray-40">
          We&apos;re sorry, but it seems like something went wrong.
          <br />
          Please try again or navigate back to the homepage.
        </p>
      </div>
      <Link to={'/'} className="flex h-[45px] w-full items-center justify-center bg-gray-20 text-c3 text-gray-40">
        Go to Homepage
      </Link>
    </div>
  </div>
);

export default Page404;
